import { render, staticRenderFns } from "./ObtainCurrentBannerComponent.vue?vue&type=template&id=16b20ff5&scoped=true&"
import script from "./ObtainCurrentBannerComponent.vue?vue&type=script&lang=js&"
export * from "./ObtainCurrentBannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ObtainCurrentBannerComponent.vue?vue&type=style&index=0&id=16b20ff5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b20ff5",
  null
  
)

export default component.exports